import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_EGRESO_CALADO } from '../../../../config/forms'
import { Button, Col } from 'react-bootstrap'
import CameraIcon from '@material-ui/icons/Camera'
import HorizontalSplitIcon from '@material-ui/icons/HorizontalSplit'
import { INTERVALO, INTERVALO_CORTO } from '../../../../config/settings'
import { ToastContainer } from 'react-toastify'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { IconButton } from '@material-ui/core'
import ReportesCamionesEgresoQR from '../../components/egresoCalado/ReportesCamionesEgresoQR'
import BarChartFilasCalado from '../../components/BarChartFilasCalado'
import EgresoCaladoQRLectura from '../../components/egresoCalado/EgresoCaladoQRLectura'
import { obtenerPedidosDeBruto, obtenerCallesDeBruto } from '../../../Pesado/actions'
import {
  consultaEstadoOcupacionCallesCalado,
  consultaCalificacionPorCalleCalado,
  getCamionesCallesDeCaladoEgreso,
  getDataCamionesCalados,
  obtenerCamionesEntrePlayaCalado,
  getDataCamionesEnPlaya,
  getCamionesListosParaBruto,
  egresoQRNextStep,
  getCeaParaEgreso,
  updateConsultaCea,
  updateViewPantallaConfirmacion,
  updateShowConfirmacionEgreso,
  obtenerProximoEgresoCalado,
  egresoQR,
  finalizarEgresoQR
} from '../../actions'
import PedidosPendientes from '../../../Pesado/components/bruto/PedidosPendientes'
import PedidosDeCamionesBruto from '../../../ReporteCamiones/components/pedidosDeCamionesBruto/PedidosDeCamionesBruto'

function EgresoCaladoQR (props) {
  const {
    stepEgresoQR,
    consultaEstadoOcupacionCallesCalado,
    consultaCalificacionPorCalleCalado,
    getCamionesCallesDeCaladoEgreso,
    getDataCamionesCalados,
    obtenerCamionesEntrePlayaCalado,
    getDataCamionesEnPlaya,
    getCamionesListosParaBruto,
    obtenerPedidosDeBruto,
    obtenerCallesDeBruto,
    obtenerProximoEgresoCalado,
    camionesPedidos
  } = props
  const [init, setInit] = useState(false)
  const [modoScan, setModoScan] = useState(false)
  const [autoClose, setAutoClose] = useState(false)
  const [proximoEgreso, setProximoEgreso] = useState(false)

  useEffect(() => {
    obtenerPedidosDeBruto()
    const actualizarPedidos = setInterval(() => {
      obtenerPedidosDeBruto()
      console.log('actualiza pedidos ', new Date())
    }, [200000])

    return () => {
      clearInterval(actualizarPedidos)
    }
  }, [obtenerPedidosDeBruto])

  useEffect(() => {
    function getData () {
      consultaEstadoOcupacionCallesCalado()
      consultaCalificacionPorCalleCalado()
      getCamionesCallesDeCaladoEgreso()
      getDataCamionesCalados()
      obtenerCamionesEntrePlayaCalado()
      getDataCamionesEnPlaya()
      getCamionesListosParaBruto()
      obtenerCallesDeBruto()
      obtenerProximoEgresoCalado()
    }

    if (!init) {
      getData()
      setInit(true)
    }

    const interval = setInterval(async () => {
      getData()
    }, [INTERVALO])

    return () => {
      clearInterval(interval)
    }
    // consultaEstadoOcupacionCallesCalado()
    // consultaCalificacionPorCalleCalado()
  }, [
    consultaEstadoOcupacionCallesCalado,
    consultaCalificacionPorCalleCalado,
    getCamionesCallesDeCaladoEgreso,
    getDataCamionesCalados,
    obtenerCamionesEntrePlayaCalado,
    getDataCamionesEnPlaya,
    getCamionesListosParaBruto,
    obtenerCallesDeBruto,
    obtenerProximoEgresoCalado,
    init,
    setInit
  ])

  useEffect(() => {
    if (props.proximoEgresoCalado) {
      setProximoEgreso(true)
    }
  }, [props.proximoEgresoCalado, setProximoEgreso])

  const nextStep = () => {
    props.egresoQRNextStep()
  }

  const openCamera = () => {
    setModoScan(false)
    nextStep()
  }

  const openScan = () => {
    setModoScan(true)
    nextStep()
  }

  const closeEgresoQR = () => {
    props.finalizarEgresoQR()
    props.updateViewPantallaConfirmacion(false)
    setInit(false)
  }

  const updateViewPantallaConfirmacion = (newValue) => {
    props.updateViewPantallaConfirmacion(newValue)
  }

  const updateShowConfirmacionEgreso = (newValue) => {
    props.updateShowConfirmacionEgreso(newValue)
  }

  const updateCea = (newValue) => {
    props.updateConsultaCea(newValue)
  }

  const egresoCaladoQR = (numero) => {
    if (numero.length < 13) {
      props.getCeaParaEgreso(numero)
    }
  }

  const egresoQR = (numero) => {
    props.egresoQR(numero)
    setAutoClose(INTERVALO_CORTO)
    setProximoEgreso(false)
    // updateViewPantallaConfirmacion(true)
  }

  const w = 770
  const h = 500
  const x2 = w - 10

  return (
    <>
      <div className='container-egreso-qr-calado'>
        <ToastContainer autoClose={autoClose} className='toast-egreso-qr' />

        {(stepEgresoQR === 1) && <div className='titulo-en-cabecera'>
          <IconButton
            onClick={closeEgresoQR}
          >
            <ArrowBackIcon />
          </IconButton>
          <h5>Egreso playa de calado</h5>
        </div>
        }

        {(stepEgresoQR === 0) && <>
          <h2 className='titulo-egreso-qr'>Estado playa de calado</h2>
          <Col md={4} style={{ margin: '12px auto' }}>
            <PedidosPendientes />
            { camionesPedidos && camionesPedidos.length > 0 && <PedidosDeCamionesBruto /> }
          </Col>
          <ReportesCamionesEgresoQR
            camionesEnPlaya={props.camionesEnPlaya}
            cpaEntrePlayaCalado={props.cpaEntrePlayaCalado}
            ceaCallesCaladoEgreso={props.ceaCallesCaladoEgreso}
            cortesPedidos={props.cortesPedidos}
            camListosParaBruto={props.camListosParaBruto}
          />

          {proximoEgreso && <></>
            // <ProximoEgresoCalado
            //   camion={props.proximoEgresoCalado}
            // />
          }

          {!props.editandoCalle &&
            <BarChartFilasCalado
              calificacionCalles={props.calificacionCalles}
              camionesCalados={props.camionesCalados}
              setCalleDeCalado={() => {}}
              estadoOcupacionCallesCalado={props.estadoOcupacionCallesCalado}
              w={w}
              h={h}
              x2={x2}
            />
          }

          <Button
            className='btn-scan-QR btn-scan-QR-cam btn-circle'
            onClick={openCamera}
          >
            <CameraIcon fontSize='large' style={{ color: '#ffffff' }} />
          </Button>
          <Button
            className='btn-scan-QR btn-scan-QR-num btn-circle'
            onClick={openScan}
          >
            <HorizontalSplitIcon fontSize='large' style={{ color: '#ffffff' }} />
          </Button>
          </>
        }

        { (stepEgresoQR === 1) && <EgresoCaladoQRLectura
          egresoCaladoQR={egresoCaladoQR}
          egresoQR={egresoQR}
          closeEgresoQR={closeEgresoQR}
          updateShowConfirmacionEgreso={updateShowConfirmacionEgreso}
          updateViewPantallaConfirmacion={updateViewPantallaConfirmacion}
          updateCea={updateCea}
          modeScan={modoScan}
        />
        }

      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    egresosSeleccionados: state.calado.egresosSeleccionados,
    cea: state.calado.consultaCea,
    cpa: state.camionesIngreso.consultaCpa,
    stepEgresoQR: state.calado.stepEgresoQR,
    estadoOcupacionCallesCalado: state.calado.estadoOcupacionCallesCalado,
    calificacionCalles: state.calado.calificacionPorCalleCalado,
    showPantallaConfirmacion: state.calado.showPantallaConfirmacion,
    ceaCallesCaladoEgreso: state.calado.ceaCallesCaladoEgreso,
    camionesCalados: state.calado.dataCamionesCalados,
    editandoCalle: state.calado.editandoCalle,
    cpaEntrePlayaCalado: state.camionesIngreso.cpaEntrePlayaCalado,
    cortesPedidos: state.camionesIngreso.cortesPedidos,
    camionesEnPlaya: state.camionesIngreso.cpaPlaya,
    camListosParaBruto: state.camionesIngreso.camListosParaBruto,
    camionesPedidos: state.pesado.camionesPedidosBruto,
    proximoEgresoCalado: state.calado.proximoEgresoCalado
  }
}

const mapActionsToProps = {
  consultaEstadoOcupacionCallesCalado,
  consultaCalificacionPorCalleCalado,
  getCamionesCallesDeCaladoEgreso,
  getDataCamionesCalados,
  obtenerCamionesEntrePlayaCalado,
  getDataCamionesEnPlaya,
  getCamionesListosParaBruto,
  obtenerPedidosDeBruto,
  obtenerCallesDeBruto,
  obtenerProximoEgresoCalado,
  egresoQRNextStep,
  getCeaParaEgreso,
  updateConsultaCea,
  updateViewPantallaConfirmacion,
  updateShowConfirmacionEgreso,
  finalizarEgresoQR,
  egresoQR
}

const withRedux = connect(mapStateToProps, mapActionsToProps)

export default withRedux(reduxForm({ form: FORM_EGRESO_CALADO })(EgresoCaladoQR))
